const filterPanelList = document.querySelectorAll('.filter-panel')
function initFilterPanel(filterPanel) {
  const inner = filterPanel.querySelector('.filter-panel__inner')
  const menu = filterPanel.querySelector('.filter-panel__menu')
  const menuItems = filterPanel.querySelector('.filter-panel__menu .items')
  const dropdownLink = filterPanel.querySelector('summary a')
  const urlSearchParams = new Proxy(
    new URLSearchParams(window.location.search),
    {
      get: (searchParams, prop) => searchParams.get(prop),
    }
  )
  const selectedCategoryId = urlSearchParams.category
  const selectedCategory =
    selectedCategoryId &&
    document.querySelector(`[data-categoryid="${selectedCategoryId}"]`)

  if (selectedCategory) {
    // Add "All positions" option to sub-list if category selected
    menuItems &&
      menuItems.insertAdjacentElement(
        'afterbegin',
        dropdownLink.cloneNode(true)
      )

    // Set dropdown to selected category from query string on page load
    const selectedCategoryLink = selectedCategory.href
    const selectedCategoryText = selectedCategory.dataset.text

    dropdownLink.href = selectedCategoryLink
    dropdownLink.dataset.text = selectedCategoryText
    dropdownLink.textContent = selectedCategoryText

    // Remove selected category from filter list to avoid duplication
    selectedCategory.remove()
  }
  if (window.innerWidth < 1024 || !inner || !menu) {
    return
  }
  function isAboveHalfway() {
    const position = inner.getBoundingClientRect().top
    return position <= window.innerHeight / 2
  }
  function scrollHandler() {
    menu.removeAttribute('open') // Close native details modal
    if (isAboveHalfway()) {
      menu.classList.add('filter-panel__menu--above-halfway-point')
    } else {
      menu.classList.remove('filter-panel__menu--above-halfway-point')
    }
  }
  let ticking = false
  document.addEventListener('scroll', function (e) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        scrollHandler()
        ticking = false
      })
      ticking = true
    }
  })
}
filterPanelList && filterPanelList.forEach(initFilterPanel)
